// "When can we call you?" Any time, or a window like "06:00 AM to 09:00 PM".
// The pickers keep 24-hour 'HH:MM'; what is saved is the 12-hour text.
export const to12h = (value) => {
    const m = /^(\d{1,2}):(\d{2})/.exec(String(value || ''));
    if (!m) return '';
    const h = Number(m[1]);
    return `${String(h % 12 === 0 ? 12 : h % 12).padStart(2, '0')}:${m[2]} ${h >= 12 ? 'PM' : 'AM'}`;
};

// -> the text to save, or '' when a specific window is not complete / start equals end
export const contactTimeText = (mode, from, to) => {
    if (mode !== 'specific') return 'Any time';
    if (!from || !to || from === to) return '';
    return `${to12h(from)} to ${to12h(to)}`;
};

// the saved text -> what the form shows: { mode: 'any' | 'specific', from: 'HH:MM', to: 'HH:MM' } (24-hour, as the time pickers use)
export const parseContactTime = (text) => {
    const m = /^(\d{2}):(\d{2}) (AM|PM) to (\d{2}):(\d{2}) (AM|PM)$/.exec(String(text || ''));
    if (!m) return { mode: 'any', from: '', to: '' };
    const to24 = (h, min, ap) => `${String((Number(h) % 12) + (ap === 'PM' ? 12 : 0)).padStart(2, '0')}:${min}`;
    return { mode: 'specific', from: to24(m[1], m[2], m[3]), to: to24(m[4], m[5], m[6]) };
};
